module.exports = __webpack_public_path__ + "static/media/climate_workplacePollutants_3_airPollutants.ca41d907.jpg";